import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[app-autocomplete-option-group-title]',
})
export class AutocompleteOptionGroupTitleDirective {
  @HostBinding('class') class = 'bg-gray-100 mb-2 px-4 py-2.5 text-xs font-semibold text-gray-900';
}
